import { useSyncExternalStore } from 'react';

type Listener = () => void;

/** Monotonic counter — each request bumps so subscribers always see a change. */
let openRequestId = 0;
const listeners = new Set<Listener>();

const subscribe = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = (): number => openRequestId;

export const requestOpenOnboardingWizard = (): void => {
  openRequestId += 1;
  listeners.forEach((listener) => listener());
};

/** Latest open-request id. Compare to a ref to detect new requests. */
export const useOnboardingWizardOpenRequestId = (): number =>
  useSyncExternalStore(subscribe, getSnapshot, () => 0);
